import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'


import { useAddressStore } from '@features/shipping-methods'
import { AddressItemType } from '@features/shipping-methods/types'

import { useSlots } from '@widgets/slots'

import Radio from '@shared/ui/radio'

import styles from './styles.module.scss'

interface Props {
  data: AddressItemType;
  onDelete: (address: AddressItemType) => void;
}

function AddressItem ({ data, onDelete }: Props) {
  const {
    address,
    address_appartments,
    address_floor,
    address_intercom,
    address_porch,
    comment,
  } = data
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { openSlotsModal } = useSlots()
  const { t: to } = useTranslation('order')
  const { t: tf } = useTranslation('favorites')
  const { isActiveAddress, setSelectedAddress, setDeliveryType } =
    useAddressStore()

  const ACTIVE = isActiveAddress(data?.id)

  const handleClick = () => {
    setSelectedAddress(data)
    openSlotsModal()
    setDeliveryType('delivery')
  }

  const addressFields = [
    { label: to('form.apartment'), value: address_appartments },
    { label: to('form.floor'), value: address_floor },
    { label: to('form.entrance'), value: address_porch },
    { label: to('form.intercom'), value: address_intercom },
  ]

  const nonEmptyFields = addressFields.filter(({ value }) => !!value)

  return (
    <div onClick={handleClick} className={styles.item}>
      <div className={styles.item__radio}>
        <Radio radioSize="large" checked={ACTIVE} />
      </div>
      <div className={styles.item__content}>
        <div className={styles.item__top}>
          <h5>{address}</h5>
          {comment && (
            <div className={styles.item__tags}>
              <span className={styles.item__tag}>{comment}</span>
            </div>
          )}
        </div>

        {nonEmptyFields.length > 0 && (
          <div className={styles.item__info}>
            {nonEmptyFields.map(({ label, value }) => (
              <span key={label} className={styles.item__field}>
                {label}: <span>{value}</span>
              </span>
            ))}
          </div>
        )}
      </div>
      <div className={styles.item__buttons}>
        <div
          className={styles.item__pin}
          aria-label="Удалить адрес"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(data)
          }}
        >
          <ReactSVG src="/icons/delete.svg" />
          {isTablet && <span>{tf('button.delete')}</span>}
        </div>
      </div>
    </div>
  )
}

export default memo(AddressItem)
